import { DocumentTypeEnum } from './enums/DocumentTypeEnum';

export type FileModelFR = {
	id: number;
	dateCreation: string;
	typeMime: string;
	nomFichier: string;
	titre: string;
	typeFichier: string;
	url: string;
};

export type FileModel = {
	id: number;
	creationDate: string;
	mimeType: string;
	fileName: string;
	title: string;
	fileType: string;
	url: string;
};

export const translateFileModel = (fm: FileModelFR): FileModel => {
	return {
		id: fm?.id,
		creationDate: fm?.dateCreation,
		mimeType: fm?.typeMime,
		fileName: fm?.nomFichier,
		title: getTitleFromType(fm),
		fileType: fm?.typeFichier,
		url: fm?.url
	};
};

export const getTitleFromType = (fm: FileModelFR): string => {
	if (fm?.typeFichier === DocumentTypeEnum.TYPE_PRESENTATION_PUBLIQUE) {
		return 'Fichier de présentation';
	}
	return fm?.titre;
};

export const translateFileModelArray = (a?: FileModelFR[]): FileModel[] => {
	return a?.map((e) => translateFileModel(e)) ?? [];
};
